import React, { useEffect, useState, useCallback } from 'react';
import { useCompanyWorkForce } from '../../../context/CompanyWorkForceContext';
import { useAuth } from '../../../context/AuthContext';
 
const AccessTab = ({ register, errors, watch ,roles,getEditData,setValue}) => {
  const { getAccessPermissions } = useCompanyWorkForce();
  const [modules, setModules] = useState([]);
  const [additionalPermissions, setAdditionalPermissions] = useState([]);
  const [workerAppEstimationPermission, setWorkerAppEstimationPermission] = useState([]);
  const [workerAppPermission, setWorkerAppPermission] = useState([]);
  const getPermissions = JSON.parse(getEditData?.permissions || '[]');
  const getAdditionalPermissions = JSON.parse(getEditData?.additional_permissions || '[]');
  const getWorkerAppEstimationPermission = JSON.parse(getEditData?.worker_app_estimation_permissions || '[]'); 
  const getWorkerAppPermission = JSON.parse(getEditData?.worker_app_permissions || '[]');
  const { user } = useAuth()
   
  const getAccessPermissionsData = useCallback(async () => {
   
     const permissions = await getAccessPermissions('all');
     if(permissions){
      setModules(permissions.modules);
      setAdditionalPermissions(permissions.additional);
      setWorkerAppEstimationPermission(permissions.workerAppEstimation);
      setWorkerAppPermission(permissions.workerApp);
     }
      
    
  },[getAccessPermissions])

  useEffect(() => {
  
    getAccessPermissionsData();
  }, [getAccessPermissionsData]);
   
  useEffect(() => {
    if (Array.isArray(getPermissions)) {
      getPermissions.forEach((permission,permissionIndex) => {
        
        setValue(`permissions[${permissionIndex}][module_id]`, permission.module_id);

        const isChecked = Number(permission.view) === 1;
        setValue(`permissions[${permissionIndex}][view]`, isChecked);

        const isCheckedCreate = Number(permission.create) === 1;
        setValue(`permissions[${permissionIndex}][create]`, isCheckedCreate);

        const isCheckedUpdate = Number(permission.update) === 1;
        setValue(`permissions[${permissionIndex}][update]`, isCheckedUpdate);

        const isCheckedDelete = Number(permission.delete) === 1;
        setValue(`permissions[${permissionIndex}][delete]`, isCheckedDelete);
      });
    }
    
  }, [getPermissions, setValue]);

  useEffect(() => {
    if (Array.isArray(getAdditionalPermissions)) {
      getAdditionalPermissions.forEach((additionalPermission,additionalPermissionIndex) => {
       
        Object.entries(additionalPermission).forEach(([key, value]) => {
         
          setValue(`additional_permissions[${additionalPermissionIndex}][${key}]`, value);
        });
      });
    }
  }, [getAdditionalPermissions, setValue]);

  useEffect(() => {
    if (Array.isArray(getWorkerAppEstimationPermission)) {
      getWorkerAppEstimationPermission.forEach((workerAppEstimationPermission,workerAppEstimationPermissionIndex) => {
        
        Object.entries(workerAppEstimationPermission).forEach(([key, value]) => {
          setValue(`worker_app_estimation_permissions[${workerAppEstimationPermissionIndex}][${key}]`, value);
        });
      });
    }
  }, [getWorkerAppEstimationPermission, setValue]);

  useEffect(() => {
    if (Array.isArray(getWorkerAppPermission)) {
      getWorkerAppPermission.forEach((workerAppPermission,workerAppPermissionIndex) => {
        Object.entries(workerAppPermission).forEach(([key, value]) => {
          setValue(`worker_app_permissions[${workerAppPermissionIndex}][${key}]`, value);
        });
      });
    }
  }, [getWorkerAppPermission, setValue]);

  return (
    <div className="space-y-6">
      {/* Basic Access Information */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Username */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Username <span className="text-red-500">*</span></label>
           
          <input
            type="text"
            {...register('username')}
            className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm ${
              errors.username ? 'border-red-500' : ''
            }`}
            placeholder="Enter Username"
          />
          {errors.username && (
            <p className="mt-1 text-sm text-red-600">{errors.username.message}</p>
          )}
        </div>

        {/* One Time User Toggle */}
        <div>
          <label className="block text-sm font-medium text-gray-700">This Is A One Time User</label>
          <div className="mt-1">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                {...register('is_one_time_user')}
                className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
                placeholder="Enter Is One Time User"
              />
              <span className="ml-2 text-sm text-gray-600">Yes</span>
            </label>
          </div>
        </div>

        {/* User Account Status */}
        <div>
          <label className="block text-sm font-medium text-gray-700">User Account Status</label>
          <div className="mt-1">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                {...register('active')}
                className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
                placeholder="Enter User Account Status"
              />
              <span className="ml-2 text-sm text-gray-600">Active</span>
            </label>
          </div>
        </div>

        {/* Account Locked Status */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Account Locked Status</label>
          <div className="mt-1">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                {...register('account_locked_status')}
                className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
                placeholder="Enter Account Locked Status"
              />
              <span className="ml-2 text-sm text-gray-600">Locked</span>
            </label>
          </div>
        </div>

        {/* Tech Support PIN */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Tech Support PIN</label>
          <input
            type="text"
            {...register('tech_support_pin')}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="Enter Tech Support PIN"
          />
        </div>
 
        {user?.role_id === 1 && (    
          <>
          {/* Role */}
        
          {roles?.data?.length > 0 && (
            <div>
              
              <label className="block text-sm font-medium text-gray-700">Role  <span className="text-red-500">*</span></label>
              <select {...register('role_id')} className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm ${
                  errors.role_id ? 'border-red-500' : ''
                }`}>
                <option value="">Select Role</option>
                {roles?.data?.map((role) => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
              {errors.role_id && (
                <p className="mt-1 text-sm text-red-600">{errors.role_id.message}</p>
              )}
            </div>
          )}
          </>
        )}

      </div>
 
      {/* System Access Permissions */}
      <div className="mt-8">
        <h3 className="text-lg font-medium text-gray-900 mb-4">System Access Permissions</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Module</th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">View</th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Create</th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Update</th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Delete</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
            {modules?.map((module,index) => {
             
              return (
                <tr key={module.id}>
                 
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {module.display_name}
                    <input
                      type="hidden"
                      {...register(`permissions[${index}][module_id]`)}
                      value={module.id}
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    
                  <input
                    type="checkbox"
                    {...register(`permissions[${index}][view]`, {
                      onChange: (e) => {
                        if (e.target.checked) {
                          setValue(`permissions[${index}][module_id]`, module.id);
                        }
                      }
                    })}
                    className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
                  />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                  <input
                      type="checkbox"
                      {...register(`permissions[${index}][create]`, {
                        onChange: (e) => {
                          if (e.target.checked) {
                            setValue(`permissions[${index}][module_id]`, module.id);
                          }
                        }
                      })}
                      className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                  <input
                      type="checkbox"
                      {...register(`permissions[${index}][update]`, {
                        onChange: (e) => {
                          if (e.target.checked) {
                            setValue(`permissions[${index}][module_id]`, module.id);
                          }
                        }
                      })}
                      className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                  <input
                      type="checkbox"
                      {...register(`permissions[${index}][delete]`, {
                        onChange: (e) => {
                          if (e.target.checked) {
                            setValue(`permissions[${index}][module_id]`, module.id);
                          }
                        }
                      })}
                      className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
                    />
                  </td>
                </tr>
              );
            })}

            </tbody>
          </table>
        </div>
      </div>

      {/* Additional User Permissions */}
      <div className="mt-8">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Additional User Permissions</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="grid grid-cols-2 gap-4">
            {additionalPermissions?.map((additionalPermission,additionalPermissionIndex) => {
              return (
                <div key={additionalPermission.id}>
                  
                  <label className="block text-sm font-medium text-gray-700">{additionalPermission.display_name}</label>
                  <input
                    type="checkbox"
                    {...register(`additional_permissions[${additionalPermissionIndex}][${additionalPermission.name}]`)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setValue(`additional_permissions[${additionalPermissionIndex}][module_id]`, additionalPermission.id);
                      }
                    }}
                    className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
                  />
                  <span className="ml-2 text-sm text-gray-600">Yes</span>
                </div>
              );
            })}
          </div>
          
        </div>
      </div>

    {/* Worker App Estimation Permissions */}
    <div className="mt-8">
    <h3 className="text-lg font-medium text-gray-900 mb-4">Worker App Estimation Permissions</h3>
      {workerAppEstimationPermission?.map((workerAppEstimationPermission,workerAppEstimationPermissionIndex) => {
        return (
          <div key={workerAppEstimationPermission.id}>
            <label className="block text-sm font-medium text-gray-700">{workerAppEstimationPermission.display_name}</label>
            <input
              type="checkbox"
              {...register(`worker_app_estimation_permissions[${workerAppEstimationPermissionIndex}][${workerAppEstimationPermission.name}]`)}
              onChange={(e) => {
                if (e.target.checked) {
                  setValue(`worker_app_estimation_permissions[${workerAppEstimationPermissionIndex}][module_id]`, workerAppEstimationPermission.id);
                }
              }}
              className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
            />
            <span className="ml-2 text-sm text-gray-600">Yes</span>
          </div>
        );
      })}
    </div>

      {/* Worker App Permissions */}
      <div className="mt-8">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Worker App Permissions</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {workerAppPermission?.map((workerAppPermission,workerAppPermissionIndex) => {
            return (
              <div key={workerAppPermission.id}>
                <label className="block text-sm font-medium text-gray-700">{workerAppPermission.display_name}</label>
                <input
                  type="checkbox"
                  {...register(`worker_app_permissions[${workerAppPermissionIndex}][${workerAppPermission.name}]`)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setValue(`worker_app_permissions[${workerAppPermissionIndex}][module_id]`, workerAppPermission.id);
                    }
                  }}
                  className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
                />
                <span className="ml-2 text-sm text-gray-600">Yes</span>
              </div>
          );
          })}
        </div>
      </div>
    </div>
  );
};

export default AccessTab; 